export default "__VITE_ASSET__BmM2ZIVs__"